import { render, staticRenderFns } from "./rewardTwoPlusGiftEdit.vue?vue&type=template&id=04860281&scoped=true&"
import script from "./rewardTwoPlusGiftEdit.vue?vue&type=script&lang=js&"
export * from "./rewardTwoPlusGiftEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04860281",
  null
  
)

export default component.exports